export default [
    {
        path: '/participacoes',
        view: 'participacoes/Index',
        name: 'Minhas Participações',
        permissions: ['RESPONDENTE'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Participações',
                disabled: true,
                exact: true,
                to: '/participacoes',
            },
        ],
    },
];
